import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useQueueSettings } from '../../../api/queue-settings';
import { QueueSettingsForm } from './QueueSettingsForm';

/**
 * Impostazioni › Coda ed email (PRD-004 US-6, PAGE-004): casella mittente, testi delle email
 * automatiche e regole della coda. Un solo record per istanza; le modifiche valgono per le
 * segnalazioni e le email successive (DEC-002 regola 4).
 */
export function QueueSettingsPage() {
  const { data, isPending, isError, error, refetch } = useQueueSettings();

  return (
    <Stack spacing={4}>
      <Stack spacing={1}>
        <Typography id="queue-settings-title" variant="h5" component="h2">
          Coda ed email
        </Typography>
        <Typography color="text.secondary">
          Da dove partono le email, cosa dicono e con quali regole si lavorano i ticket.
        </Typography>
      </Stack>

      <Alert severity="info" role="note">
        Le modifiche valgono per le segnalazioni e le email successive, non per quelle già in corso.
      </Alert>

      {isPending && (
        <Stack direction="row" spacing={2} alignItems="center" role="status">
          <CircularProgress size={20} />
          <Typography>Caricamento delle impostazioni…</Typography>
        </Stack>
      )}

      {isError && (
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={() => void refetch()}>
              Riprova
            </Button>
          }
        >
          <AlertTitle>Impostazioni non disponibili</AlertTitle>
          {error.message}
        </Alert>
      )}

      {data && <QueueSettingsForm settings={data} />}
    </Stack>
  );
}
